import React from "react";
import { Link } from "react-router-dom";

import serviceHero from "../assets/services1.png";

// import ALL images
import web from "../assets/web.png";
import design from "../assets/design.png";
import seo from "../assets/seo.png";
import mobile from "../assets/mobile.png";
import software from "../assets/software.png";
import graphic from "../assets/graphic.png";
import marketing from "../assets/marketing.png";
import security from "../assets/security.png";
import content from "../assets/content.png";
import ecommerce from "../assets/ecommerce.png";
import consulting from "../assets/consulting.png";
import ai from "../assets/ai.png";
import aiIntegration from "../assets/ai2.png";
import data from "../assets/data.png";
import team from "../assets/team.png";

const Services = () => {

  const services = [
    { title: "Web Development", img: web, desc: "Fast, secure, scalable websites." },
    { title: "UI/UX Design", img: design, desc: "Modern and user-friendly interfaces." },
    { title: "SEO Optimization", img: seo, desc: "Improve rankings and visibility." },
    { title: "Mobile App Development", img: mobile, desc: "Android, iOS & cross-platform apps." },
    { title: "Software Development", img: software, desc: "Custom business software solutions." },
    { title: "Graphic Design", img: graphic, desc: "Creative visuals for branding." },
    { title: "Digital Marketing", img: marketing, desc: "Grow your online presence." },
    { title: "Cybersecurity", img: security, desc: "Protect your digital assets." },
    { title: "Content Writing", img: content, desc: "Engaging and high-quality content." },
    { title: "E-commerce Solutions", img: ecommerce, desc: "Conversion-focused online stores." },
    { title: "IT Consulting", img: consulting, desc: "Expert tech guidance." },
    { title: "AI Automation", img: ai, desc: "Automate tasks with AI." },
    { title: "AI Integration", img: aiIntegration, desc: "Integrate AI into systems." },
    { title: "AI & Data Solutions", img: data, desc: "Turn data into insights." },
    { title: "Staff Augmentation", img: team, desc: "Extend your team on demand." },
  ];

  return (
    <div className="text-white overflow-hidden">

      {/* ================= HERO ================= */}
      <section
        className="relative h-[80vh] flex items-center justify-center text-center"
        style={{
          backgroundImage: `url(${serviceHero})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/80"></div>

        <div className="relative z-10 px-6">
          <h1 className="text-4xl md:text-6xl font-bold">
            Our <span className="text-purple-400">Services</span>
          </h1>

          <p className="mt-6 text-gray-300 max-w-2xl mx-auto text-lg">
            We provide cutting-edge digital solutions to help your business grow,
            scale, and succeed in the modern world.
          </p>
        </div>
      </section>

      {/* ================= SERVICES GRID ================= */}
      <section className="py-24 px-6 bg-[#0b1a35] text-center">

        <h2 className="text-5xl font-bold mb-16">
          What We <span className="text-purple-400">Offer</span>
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10 max-w-6xl mx-auto">

          {services.map((service, i) => (
            <div
              key={i}
              className="group rounded-2xl overflow-hidden bg-[#112240] hover:-translate-y-2 transition duration-300"
            >
              <div className="relative">
                <img
                  src={service.img}
                  alt={service.title}
                  className="h-52 w-full object-cover group-hover:scale-110 transition duration-500"
                />
                <div className="absolute inset-0 bg-black/50"></div>
              </div>

              <div className="p-6">
                <h3 className="text-xl font-semibold mb-3 group-hover:text-purple-400">
                  {service.title}
                </h3>

                <p className="text-gray-400 text-sm">
                  {service.desc}
                </p>
              </div>
            </div>
          ))}

        </div>
      </section>

      {/* ================= PROCESS ================= */}
      <section className="py-24 px-6 bg-[#081225] text-center">

        <h2 className="text-5xl font-bold mb-16">
          Our <span className="text-purple-400">Process</span>
        </h2>

        <div className="grid md:grid-cols-4 gap-10 max-w-6xl mx-auto">

          {["Research", "Planning", "Development", "Launch"].map((step, i) => (
            <div
              key={i}
              className="p-8 bg-[#112240] rounded-xl hover:scale-105 transition"
            >
              <h3 className="text-xl font-semibold">{step}</h3>
            </div>
          ))}

        </div>
      </section>

      {/* ================= ADD-ONS ================= */}
      <section className="py-20 px-6 text-center bg-gradient-to-r from-purple-600 to-pink-500">

        <h2 className="text-4xl font-bold mb-10">Optional Add-Ons</h2>

        <div className="flex flex-wrap justify-center gap-6">
          {[
            "Maintenance & Support",
            "Cloud Deployment",
            "Analytics Integration",
          ].map((addon, i) => (
            <div
              key={i}
              className="bg-white/10 px-6 py-3 rounded-full backdrop-blur-md hover:scale-105 transition"
            >
              {addon}
            </div>
          ))}
        </div>
      </section>

      {/* ================= CTA ================= */}
      <section className="py-24 px-6 text-center">

        <h2 className="text-5xl font-bold mb-6">
          Ready to Start Your <span className="text-purple-400">Project?</span>
        </h2>

        <p className="text-gray-300 mb-8">
          Let’s build something powerful together.
        </p>

        <Link to="/contact">
          <button className="px-10 py-4 bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl hover:scale-105 transition">
            Contact Us
          </button>
        </Link>

      </section>

    </div>
  );
};

export default Services;